export const contextScenarios = [
  // Fiction genres
  "a detective novel",
  "a science fiction story",
  "a fantasy adventure",
  "a romance novel",
  "a thriller",
  "a horror story",
  "a historical novel set in the Middle Ages",
  "a historical novel set in ancient Rome",
  "a coming-of-age story",
  "a spy thriller",
  "a dystopian novel",
  "a mystery novel",
  "a gothic novel",
  "a fairy tale",
  "a fable with a moral lesson",
  "a short story by a literary author",
  "a magical realism novel",
  "a pirate adventure story",
  "a Western novel",
  "a war novel",
  "a ghost story",
  "a psychological thriller",
  "a satirical novel",
  "a comic novel",
  "a noir crime story",
  "a children's adventure book",
  "a young adult novel",
  "a post-apocalyptic story",
  "a space opera",
  "a cyberpunk story",
  "a myth or legend retold",
  "a courtroom drama",
  "a road trip story",
  "a survival story",
  "a heist story",
  // Non-fiction & journalism
  "a newspaper article about politics",
  "a newspaper article about economics",
  "a sports news report",
  "a technology news article",
  "a science journal article",
  "a nature documentary narration",
  "a history textbook",
  "a philosophy book",
  "a psychology textbook",
  "a sociology essay",
  "a travel guidebook",
  "a biography of a famous person",
  "an autobiography",
  "a memoir about childhood",
  "a memoir about immigration",
  "a self-help book",
  "a business book",
  "an economics article",
  "a climate change report",
  "a medical journal article",
  "a nutrition article",
  "a fitness magazine",
  "a parenting advice column",
  "an art history book",
  "a music review",
  "a film review",
  "a book review",
  "a restaurant review",
  "a product review",
  "an opinion editorial",
  "an investigative journalism piece",
  "a cultural commentary essay",
  "a wildlife documentary script",
  "an archaeology article",
  "a linguistics article",
  // Everyday life & conversations
  "a conversation between friends at a café",
  "a conversation between coworkers",
  "a family dinner conversation",
  "a phone call between old friends",
  "an argument between roommates",
  "a first date conversation",
  "a job interview",
  "a conversation at a doctor's office",
  "a conversation at a market or shop",
  "a conversation between neighbors",
  "a conversation between a teacher and student",
  "a conversation at a party",
  "a conversation between strangers on a train",
  "a parent explaining something to a child",
  "a teenager's diary entry",
  "a complaint to customer service",
  "a conversation at a hair salon",
  "a chat between gym buddies",
  "a text message exchange between siblings",
  // Professional & academic
  "a university lecture",
  "a TED talk",
  "a courtroom proceeding",
  "a political speech",
  "a wedding toast",
  "a graduation speech",
  "a corporate presentation",
  "a scientific conference talk",
  "an investor pitch",
  "a diplomatic negotiation",
  "a legal contract explanation",
  "a police report",
  "an engineering specification document",
  "an architectural project description",
  // Creative & arts
  "a poem",
  "a song lyric",
  "a play or theater script",
  "a movie screenplay",
  "a stand-up comedy routine",
  "a monologue in a one-person show",
  "a love letter",
  "a breakup letter",
  "a letter of recommendation",
  "a postcard from vacation",
  "a personal journal or diary entry",
  "a eulogy",
  // Food & cooking
  "a recipe introduction",
  "a food blog post",
  "a restaurant menu description",
  "a wine tasting note",
  "a cookbook foreword",
  "a street food vendor's pitch",
  // Travel & places
  "a travel blog post",
  "a hotel review",
  "a hiking trail description",
  "a city walking tour narration",
  "a backpacker's journal",
  "a cruise ship brochure",
  "a museum audio guide",
  "a national park information panel",
  "an airline in-flight announcement",
  "a description of a bustling marketplace",
  // Technology & modern life
  "a tech blog post",
  "an app store description",
  "a software tutorial",
  "a social media post",
  "a podcast transcript",
  "a YouTube video description",
  "an online forum discussion",
  "a video game narrative",
  "a user manual",
  "a cybersecurity warning",
  // Nature & science
  "a nature writing essay",
  "a field guide entry about an animal",
  "a field guide entry about a plant",
  "an astronomy article",
  "a geology textbook",
  "a weather forecast",
  "a marine biology article",
  "an environmental activism pamphlet",
  "a gardening magazine article",
  "a veterinarian's case notes",
  // History & culture
  "a historical account of an ancient civilization",
  "a description of a cultural festival",
  "a folklore collection",
  "an anthropology field study",
  "a museum exhibit description",
  "a description of a traditional ceremony",
  "a retelling of a historical battle",
  "an immigration story",
  "a description of daily life in the 1920s",
  "a medieval chronicle",
  // Sports & hobbies
  "a live sports commentary",
  "a sports interview after a big game",
  "a chess match analysis",
  "a fishing trip story",
  "a mountaineering expedition journal",
  "a martial arts training manual",
  "a dance class description",
  "a surfing magazine article",
  "a photography tutorial",
  "a board game review",
  // Emotions & relationships
  "a therapist's session notes",
  "a self-reflection essay about personal growth",
  "a story about overcoming a fear",
  "a story about a childhood memory",
  "a story about losing and finding something precious",
  "a narrative about moving to a new country",
  "a story about an unexpected friendship",
  "a meditation guide",
  "a gratitude journal entry",
  // Commerce & practical
  "a real estate listing",
  "an auction announcement",
  "a classified advertisement",
  "a warranty explanation",
  "a customer testimonial",
  "a charity fundraising appeal",
  "a job posting",
  "a cover letter",
  "instructions for assembling furniture",
  "a safety briefing",
  // Miscellaneous vivid scenarios
  "a message in a bottle",
  "a fortune teller's prediction",
  "a ship captain's log",
  "a zookeeper's daily report",
  "a librarian's book recommendation",
  "a street musician describing their day",
  "a farmer's almanac entry",
  "a beekeeper's journal",
  "a firefighter's incident report",
  "a deep sea diver's log",
  "a storm chaser's field notes",
  "a circus ringmaster's announcement",
  "a magician explaining a trick",
  "a detective's case notes",
  "a pilot's pre-flight briefing",
  "a diplomat's private diary",
  "an astronaut's mission log",
  "a mountain hermit's reflections",
  "a street artist describing their mural",
  "a night watchman's observations",
];

export const getRandomScenario = () =>
  contextScenarios[Math.floor(Math.random() * contextScenarios.length)];
